import React, { useState, useEffect, useRef } from "react";
import { debounce } from "lodash";
import "./styles.scss";
import Select from "components/select/Select";
import { convertOption, appendDupSuffix } from "utils";
import useNotify from "hooks/useNotify";
import Menu from "components/menu/Menu";
import { useLocation } from "react-router-dom";
import { getPatients, getPatientByFacilities, resetPatientList } from "store/patients/actions";

import {
  getMaster,
  getGroupByFacility
} from "store/master/actions";
import { useDispatch } from "react-redux";
import MenuList from "components/menu/MenuList";
import MenuListAdmin from "components/menu/MenuListAdmin";
import MenuListPartner from "components/menu/MenuListPartner";
import PartnerApiHook from "hooks/partner/partnerApiHook";
import PartnerHook from "hooks/partner/partnerHook";
import FacilityHook from "hooks/facility/facilityHook";
import FacilityApiHook from "hooks/facility/facilityApiHook";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import i18n from "../../i18n";
import { MenuOnlyFirst } from "components/menu/MenuOnlyFirst";
import HomeHook from "hooks/home/homeHook";
import { useHistory } from "react-router-dom";


const langOpt = [
  {
    label: "日本", value: "JP"
  },
  {
    label: "한국", value: "KR"
  },
  {
    label: "繁体", value: "TW"
  },
  {
    label: "香港", value: "HK"
  },
  {
    label: "简体", value: "CN"
  },
  {
    label: "EN", value: "EN"
  },
];

function AppHeader() {
  const { t } = useTranslation();
  const location = useLocation();
  // #10: deep-link — nếu URL có ?partner=&business= thì seed vào localStorage TRƯỚC khi
  // các init/restore đọc localStorage, để filter áp dụng đúng theo URL khi load/F5.
  {
    const sp = new URLSearchParams(location.search);
    const up = sp.get("partner");
    const ub = sp.get("business");
    if (up) localStorage.setItem("PARTNER_PARAM", up);
    if (ub) localStorage.setItem("FACILITY_PARAM", ub);
  }
  const menuList = MenuList();
  const menuListAdmin = MenuListAdmin();
  const menuListPartner = MenuListPartner();
  const menuFirstOnly = MenuOnlyFirst();
  let dispatch = useDispatch();
  const lang = localStorage.getItem("LANG");
  const isMainScreen = location.pathname === "/";

  const { staffs, groups } = useSelector((state) => state.MasterReducer);
  const { devices } = useSelector((state) => state.DeviceReducer);
  const { patients } = useSelector((state) => state.PatientReducer);
  const { loadingFacilities, facilityByPartnerError } = useSelector((state) => state.FacilityReducer);

  const { showToastError } = useNotify();
  // #5: đang reload options 事業者名 → disable dropdown, tránh spam click.
  // Chỉ dùng loadingFacilities (không dùng loadingPatients vì auto-refresh 5s sẽ bật cờ này liên tục).
  const loadingFilter = loadingFacilities;
  // #5: debounce 300ms — gọi nhiều lần liên tiếp chỉ chạy lần cuối (coalesce spam)
  // 2 debounce RIÊNG: 1 cho load options 事業者名, 1 cho load list patient.
  // KHÔNG dùng chung 1 instance, nếu không 2 thao tác khác nhau (khi đổi 提携先)
  // sẽ ghi đè/hủy lẫn nhau → patient-load bị bỏ.
  const debouncedFacilityLoad = useRef(debounce((fn) => fn(), 300)).current;
  const debouncedPatientLoad = useRef(debounce((fn) => fn(), 300)).current;

  const { getListPartner } = PartnerApiHook();
  const { partnerList } = PartnerHook();
  const { getListFacilityByPartner, resetMessage: resetFacilityMessage } = FacilityApiHook();
  const { facilityListByPartner, facilityList } = FacilityHook();
  const { usageLicense } = HomeHook();
  const history = useHistory();
  const params = new URLSearchParams(location.search);
  const initialSearch = params.get("search") || "";
  const [inputValue, setInputValue] = useState(initialSearch);
  const userInfoString = Cookies.get("USER_INFO");

  const getPatientParam = () => {
    try {
      const data = localStorage.getItem("PATIENT_PARAM");
      return data ? JSON.parse(data) : {};
    } catch {
      return {};
    }
  };

  const [userInfo, setUserInfo] = useState({});
  const [staff, setStaff] = useState(getPatientParam().staff_id || null);
  const [group, setGroup] = useState(getPatientParam().group_id || null);

  const [staffOptions, setStaffOptions] = useState([]);
  const [groupOptions, setGroupOptions] = useState([]);
  const [partnerOptions, setPartnerOptions] = useState([]);
  const [facilityOptions, setFacilityOptions] = useState([]);
  const [screenName, setScreenName] = useState("");

  const [numActive, setNumActive] = useState(0);

  const param = localStorage.getItem("PATIENT_PARAM_ADMIN");
  // TODO : use Store reduce
  // total_use_licenses
  const [numInactive, setNumInactive] = useState(0);
  const [numNotRegisted, setNumNotRegisted] = useState(0);
  const [numAlert, setNumAlert] = useState(0);

  const getInitialPartner = () => localStorage.getItem("PARTNER_PARAM") || "SANWA";
  const [partner, setPartner] = useState(getInitialPartner());
  const [roleAdmin, setRoleAdmin] = useState(false);
  const [rolePartner, setRolePartner] = useState(false);
  const [roleFacility, setRoleFacility] = useState(false);

  const getInitialFacility = () => {
    const f = localStorage.getItem("FACILITY_PARAM");
    if (f === "undefined" || !f) return null;
    return f;
  };
  const [facility, setFacility] = useState(getInitialFacility());

  const [language, setLanguage] = useState("");

  useEffect(() => {
    if (lang) {
      setLanguage(lang);
      i18n.changeLanguage(lang);
    }
  }, [lang]);

  useEffect(() => {
    const roleAdmin = userInfo && userInfo.is_sys_admin;
    if (roleAdmin) {
      getListPartner();
    }
    if (userInfo) {
      setRoleAdmin(userInfo && userInfo.is_sys_admin);
      setRolePartner(userInfo && !userInfo.is_sys_admin && userInfo.role === 'ROLE_PARTNER');
      setRoleFacility(userInfo && !userInfo.is_sys_admin && userInfo.role == 'ROLE_FACILITY');
    }
  }, [userInfo]);
  // #3: load options 事業者名 thất bại → toast lỗi, giữ dropdown cũ (reducer không xóa list), cho phép retry
  useEffect(() => {
    if (facilityByPartnerError) {
      showToastError(t("msg.fetch_failed"));
      resetFacilityMessage();
    }
  }, [facilityByPartnerError]);

  useEffect(() => {
    const roleAdmin = userInfo && userInfo.is_sys_admin;
    const rolePartner = userInfo && !userInfo.is_sys_admin && userInfo.role === 'ROLE_PARTNER';
    // #5: debounce 300ms để gộp các lần đổi 提携先 liên tiếp (spam click)
    if (roleAdmin) {
      debouncedFacilityLoad(() => getListFacilityByPartner({ partner_id: partner == "SANWA" ? "DEFAULT_SANWA" : partner }));
    }
    if (rolePartner) {
      debouncedFacilityLoad(() => getListFacilityByPartner({ partner_id: userInfo.id }));
    }
  }, [partner, userInfo, facilityList]);
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const searchParam = params.get("search") || "";
    let patientListSearch = patients;
    // if (searchParam != '') {
    patientListSearch = (patients || []).filter(patient =>
      patient.code?.toLowerCase().includes(searchParam.toLowerCase())
    );
    // }
    if (patientListSearch?.length > 0) {
      let nActive = 0;
      let nInactive = 0;
      let nNotRegisted = 0;
      let nAlert = 0;
      patientListSearch.forEach((pa) => {
        const foundDevice = devices.find((d) => d.patient_id === pa.id);
        if (foundDevice) {

          if (foundDevice?.diaper) {
            nActive++;
          } else if (foundDevice?.mac && foundDevice?.transmitter_mac && foundDevice?.is_removed_diaper) {
            nInactive++;
          }
          if (foundDevice?.notify_temp_clothing == true || foundDevice?.notify_sleeping_pos == true || foundDevice?.diaper_status == 'R' ||
            (foundDevice?.battery_status == 'AD_BAT_VOL_LOWER_THRS' || foundDevice?.battery_status == 'AD_BAT_VOL_POWER_OFF')) {
            nAlert++;
          }
          if (foundDevice?.transmitter_mac == undefined) {
            nNotRegisted++;
          }
        } else {
          nNotRegisted++;
        }
      });
      setNumActive(nActive);
      setNumInactive(nInactive);
      setNumNotRegisted(nNotRegisted);
      setNumAlert(nAlert);
    }
    if (patientListSearch?.length == 0) {
      setNumActive(0);
      setNumInactive(0);
      setNumNotRegisted(0);
      setNumAlert(0);
    }
  }, [devices, patients, initialSearch]);

  useEffect(() => {
    if (userInfoString) {
      setUserInfo(JSON.parse(userInfoString));
    }
  }, [userInfoString]);
  useEffect(() => {
    if (staffs?.length > 0) {
      let array = [{ label: t("all"), value: null }];
      const convert = convertOption(staffs);
      setStaffOptions(array.concat(convert));
    } else {
      setStaffOptions([]);
    }
  }, [staffs, language]);
  useEffect(() => {
    if (groups?.length > 0) {
      let array = [{ label: t("all"), value: null }];
      const convert = convertOption(
        groups?.filter((g) => g.name !== "DEFAULT")
      );
      setGroupOptions(array.concat(convert));
    } else {
      setGroupOptions([]);
    }
  }, [groups, language]);
  useEffect(() => {
    if (location.pathname) {
      let menus = null;
      if (!userInfo.confirm_info && !isAdminSanwa(userInfo)) {
        menus = menuFirstOnly;
      } else
        if (userInfo.role === "ROLE_FACILITY" && userInfo.is_sys_admin) {
          menus = menuListAdmin;
        } else if (userInfo.role === "ROLE_FACILITY" && !userInfo.is_sys_admin) {
          setFacility(userInfo.id);
          menus = menuList;
        } else if ((userInfo.role === "ROLE_PARTNER" || userInfo.role) && !userInfo.is_sys_admin) {
          setPartner(userInfo.id);
          menus = menuListPartner;
        }
      if (menus) {
        const foundMenu = menus.findLast((menu) =>
          location.pathname.includes(menu.url)
        );
        if (foundMenu) {
          if (foundMenu.childs?.length > 0) {
            const foundChild = foundMenu.childs.find((c) =>
              location.pathname.includes(c.url)
            );
            if (foundChild) setScreenName(foundChild.title);
          } else {
            setScreenName(foundMenu.title);
          }
          if (location.pathname?.includes("analytic-urine")) {
            const title = getNameOfAnalyticUrine(lang);
            setScreenName(title);
          }

          if (location.pathname?.includes("payment-detail")) {
            const title = getTitlePaymentDetail(lang);
            setScreenName(title);
          }
        } else {
          setScreenName("");
        }
      }
    }
  }, [menuListAdmin, location.pathname, userInfo]);

  const getNameOfAnalyticUrine = (lang) => {
    if (lang === 'KR') {
      return "분석 그래프";
    } else if (lang === 'TW' || lang === 'HK') {
      return "分析圖表";
    } else if (lang === 'CN') {
      return "分析图表";
    } else if (lang === 'EN') {
      return "Analytical Graph";
    } else {
      return "分析グラフ";
    }
  };

  const getTitlePaymentDetail = (lang) => {
    if (lang === 'KR') {
      return "연간 유지 보수 요금 조회";
    } else if (lang === 'TW' || lang === 'HK') {
      return "年度維護費用查詢";
    } else if (lang === 'CN') {
      return "年度维护费用查询";
    } else if (lang === 'EN') {
      return "Annual Maintenance Fee Inquiry";
    } else {
      return "年間保守料金照会";
    }
  };

  useEffect(() => {
    const roleAdmin = userInfo && userInfo.is_sys_admin
    if (roleAdmin) {
      if (partnerList) {
        const data = [
          { value: "SANWA", label: t('no_partner'), title: t('no_partner') },
          { value: "ALL", label: t('all_partners'), title: t('all_partners') },
        ];
        // #9: thêm suffix "(ID:xxx)" nếu trùng tên; #7: title để hover hiện tên đầy đủ
        const partnerMap = appendDupSuffix(partnerList).map((item) => ({
          value: item.id,
          label: item.name,
          title: item.name,
        }));
        data.push(...partnerMap);
        setPartnerOptions(data);

        const storedPartner = localStorage.getItem("PARTNER_PARAM");
        const found = storedPartner && data.find((p) => String(p.value) === String(storedPartner));
        // #6: partner đã chọn bị xóa khỏi DB (không còn trong options) → reset về 全ての提携先 (ALL)
        const nextPartner = found ? storedPartner : (storedPartner ? "ALL" : data[0].value);
        setPartner(nextPartner);

        // #6: nếu partner đã chọn bị xóa → dọn luôn URL + localStorage về ALL/全て
        // (nếu không, IIFE seed-từ-URL sẽ liên tục đẩy lại id cũ → URL bẩn + nhấp nháy).
        if (storedPartner && !found) {
          localStorage.setItem("PARTNER_PARAM", "ALL");
          localStorage.setItem("FACILITY_PARAM", "ALL");
          const sp = new URLSearchParams(location.search);
          sp.set("partner", "ALL");
          sp.set("business", "ALL");
          history.replace(`${location.pathname}?${sp.toString()}`);
        }
      }
    }
  }, [partnerList]);

  useEffect(() => {
    if (facilityListByPartner) {
      let data = []
      if (partner == "SANWA" && isAdminSanwa(userInfo)) {
        data = [{
          // 全ての事業者 = tất cả CƠ SỞ chưa gán 提携先 (spec case 3). Không gồm 利用者 chưa
          // thuộc cơ sở nào — nhóm đó nằm ở option 事業者連携なし bên dưới (case 7).
          // Dùng cùng nhãn với màn hình ダウンロード để tránh hiểu nhầm là "tất cả 利用者".
          value: "ALL",
          label: t('all_facilities'),
          title: t('all_facilities'),
        },
        {
          // 事業者連携なし: 利用者 chưa gán 事業者 nào và không qua 提携先.
          // Đặt cùng vị trí với nhánh partner để thứ tự dropdown nhất quán.
          value: "INDIVIDUAL",
          label: t('personal'),
        },
        // #9: suffix "(ID:xxx)" nếu trùng tên; #7: title để hover hiện tên đầy đủ
        ...appendDupSuffix(facilityListByPartner).map(item => ({
          value: item.id,
          label: item.name,
          title: item.name,
        })),
        ]
      }

      if (partner !== "SANWA" && facilityListByPartner.length > 0) {
        const conditionalItems = partner === "ALL" ? [] : [{
          value: "INDIVIDUAL",
          label: t('personal'), /// mean all user
        }];

        data = [{
          value: "ALL",
          label: t('all'),
          title: t('all'),
        },
        ...conditionalItems,
        // #9: suffix "(ID:xxx)" nếu trùng tên; #7: title để hover hiện tên đầy đủ
        ...appendDupSuffix(facilityListByPartner).map(item => ({
          value: item.id,
          label: item.name,
          title: item.name,
        })),
        ];
      }

      // Edge case #1: partner đang chọn không có cơ sở nào
      // → dropdown 事業者名 vẫn phải có option 全て (ALL), grid sẽ rỗng + hiển thị message.
      if (partner !== "SANWA" && facilityListByPartner.length === 0) {
        data = [{ value: "ALL", label: t('all') }];
      }

      setFacilityOptions(data);
      if (data.length > 0) {
        console.log("AppHeader -> loaded facilityOptions data:", data);

        const savedFacility = localStorage.getItem("FACILITY_PARAM");
        let initialVal = data[0].value;
        // savedFacility === "undefined" là giá trị của bản cũ (ALL_PERSONAL) → bỏ qua,
        // rơi về data[0] = 全て (ALL).
        if (savedFacility && savedFacility !== "undefined" && data.find(item => String(item.value) === String(savedFacility))) {
          initialVal = savedFacility;
        }

        setFacility(initialVal);
        const initialParams = { facility_id: initialVal, group_id: group, partner_id: partner, patient_id: undefined };
        dispatch(getPatientByFacilities(initialParams));
        dispatch(getGroupByFacility({ facilityId: initialVal, partnerId: partner }))
        localStorage.setItem("PATIENT_PARAM_ADMIN", JSON.stringify(initialParams));
        localStorage.setItem("PATIENT_PARAM_ADMIN2", JSON.stringify(initialParams));
        localStorage.setItem("FACILITY_PARAM", initialVal);
        localStorage.setItem("PARTNER_PARAM", partner);
        console.log("AppHeader -> facility set to:", initialVal, "partner:", partner);

      } else {
        setFacility(null);
        // localStorage.removeItem("PATIENT_PARAM_ADMIN")
        dispatch(resetPatientList())
      }
    }

  }, [facilityListByPartner]);

  useEffect(() => {
    if (localStorage.getItem("IMMEDIENTLY_FILTER_INDIVIDUAL") === true) {
      setFacility('INDIVIDUAL');
      dispatch(resetPatientList())
      localStorage.setItem("IMMEDIENTLY_FILTER_INDIVIDUAL", false);
    }

  }, [
    localStorage.setItem("IMMEDIENTLY_FILTER_INDIVIDUAL", false)
  ]);

  const onChangeLang = (value) => {
    setLanguage(value);
    localStorage.setItem("LANG", value);
    i18n.changeLanguage(value);
    dispatch(getMaster());
  };
  const goHome = () => {
    window.location.href = "/";
  };
  const onChangeStaff = (value) => {
    setStaff(value);
    const data = {
      name: "",
      staff_id: value || "",
      group_id: group || "",
    };
    dispatch(getPatients(data));
    localStorage.setItem("PATIENT_PARAM", JSON.stringify(data));
  };
  const onChangeGroup = (value) => {
    setGroup(value);
    const data = {
      name: "",
      staff_id: staff || "",
      group_id: value || "",
    };
    dispatch(getPatients(data));
    localStorage.setItem("PATIENT_PARAM", JSON.stringify(data));
  };
  // #10: ghi state filter vào URL query (?partner=&business=), giữ nguyên các param khác (vd search)
  const syncFilterToUrl = (partnerVal, businessVal) => {
    const sp = new URLSearchParams(location.search);
    if (partnerVal != null) sp.set("partner", partnerVal);
    if (businessVal != null) sp.set("business", businessVal);
    history.replace(`${location.pathname}?${sp.toString()}`);
  };

  const onChangePartner = (value) => {
    setPartner(value);
    // Edge case #2: đổi 提携先 → reset 事業者名 về 全て NGAY (tức thì), tránh nháy/stale
    // và chặn effect khôi phục lại cơ sở cũ (X không thuộc partner mới).
    // 全て dùng chung một giá trị "ALL" cho mọi 提携先 (kể cả 提携先無し):
    // = tất cả CƠ SỞ trong phạm vi partner đó. Nhóm 利用者 chưa thuộc cơ sở nào
    // được lọc riêng qua option 事業者連携なし (INDIVIDUAL).
    const allFacilityValue = "ALL";
    const businessParam = "ALL";
    setFacility(allFacilityValue);
    localStorage.setItem("FACILITY_PARAM", businessParam);
    localStorage.setItem("PARTNER_PARAM", value);
    syncFilterToUrl(value, businessParam); // #10

    // Reload list user NGAY theo partner mới (事業者名 = 全て), không phụ thuộc việc load
    // options 事業者名 có thành công hay không. Nếu API fail (vd mất mạng) → reducer xóa
    // list cũ + báo lỗi + hiện nút refresh thay vì giữ nguyên list của partner trước.
    const patientParams = {
      partner_id: value,
      facility_id: allFacilityValue,
      group_id: group,
      patient_id: undefined,
    };
    localStorage.setItem("PATIENT_PARAM_ADMIN", JSON.stringify(patientParams));
    localStorage.setItem("PATIENT_PARAM_ADMIN2", JSON.stringify(patientParams));
    debouncedPatientLoad(() => dispatch(getPatientByFacilities(patientParams)));
  };

  const onChangeFacility = (value) => {
    setFacility(value)
    const patientParams = { partner_id: partner, facility_id: value, group_id: group, patient_id: undefined };
    // #5: debounce 300ms việc gọi grid khi đổi 事業者名 liên tiếp
    debouncedPatientLoad(() => dispatch(getPatientByFacilities(patientParams)));
    dispatch(getGroupByFacility({ facilityId: value, partnerId: partner }))

    const businessParam = value;
    localStorage.setItem("PATIENT_PARAM_ADMIN", JSON.stringify(patientParams));
    localStorage.setItem("PATIENT_PARAM_ADMIN2", JSON.stringify(patientParams));
    localStorage.setItem("FACILITY_PARAM", businessParam);
    localStorage.setItem("PARTNER_PARAM", partner);
    syncFilterToUrl(partner, businessParam); // #10
  };
  const isAdminSanwa = (userInfo) => userInfo.role == "ROLE_FACILITY" && userInfo.is_sys_admin;


  if (!isMainScreen) {
    return (
      <div className="header-container">
        <div className="header-container-left">
          <Menu />
          <div className="header-item">
            <img src="/icons/logo.png" className="logo-icon" onClick={goHome} />
          </div>
          <div className="header-container-item">
            <div className="header-screen-name">{screenName}</div>
          </div>
        </div>
        {!isAdminSanwa(userInfo) && <Select
          value={language}
          options={langOpt}
          onChange={onChangeLang}
          width={70}
        />}
      </div>
    );
  }

  const handleSearch = (value) => {
    // #10: giữ partner/business hiện có trên URL, chỉ cập nhật search
    const sp = new URLSearchParams(location.search);
    if (value) sp.set("search", value);
    else sp.delete("search");
    history.push(`/?${sp.toString()}`);
  };

  return (
    <div className="header-container-main">
      <Menu />
      <div className="header-item">
        <img src="/icons/logo.png" className="logo-icon" onClick={goHome} />
      </div>
      <div className="header-item search-group">
        <input
          type="text"
          placeholder={t("searching_patient_by_id")}
          className="search-input"
          value={inputValue}
          onChange={(e) => { setInputValue(e.target.value); handleSearch(e.target.value); }}
        />
      </div>
      {roleFacility &&
        <div className="header-item-center">
          <div className="header-item-row">{t("number_of_licenses")}</div>
          <div className="header-item-row">
            {Math.min(usageLicense ?? 0, userInfo?.number_of_licenses ?? 0)}/
            {userInfo?.number_of_licenses || 0}
          </div>
        </div>
      }
      <div className="header-item-filter">
        {roleFacility &&
          <div className="header-item-row">
            <div className="header-item-row-label v1">{t("pic")}：</div>
            <div className="header-item-row-content">
              <Select
                value={staff}
                options={staffOptions}
                onChange={onChangeStaff}
                width={150}
              />
            </div>
          </div>
        }
        {roleFacility &&
          <div className="header-item-row">
            <div className="header-item-row-label v1">{t("group")}：</div>
            <div className="header-item-row-content">
              <Select
                value={group}
                options={groupOptions}
                onChange={onChangeGroup}
                width={150}
              />
            </div>
          </div>
        }
        {roleAdmin &&
          <div className="header-item-row">
            <div className="header-item-row-label v1">{t("filter.partner")}：</div>
            <div className="header-item-row-content">
              <Select
                value={partner}
                options={partnerOptions}
                onChange={onChangePartner}
                width={150}
                disabled={loadingFilter}
              />
            </div>
          </div>
        }
        {(roleAdmin || rolePartner) &&
          <div className="header-item-row">
            <div className="header-item-row-label v1">{t("filter.facility")}：</div>
            <div className="header-item-row-content">
              <Select
                value={facility}
                options={facilityOptions}
                onChange={onChangeFacility}
                width={150}
                disabled={loadingFilter}
              />
            </div>
          </div>
        }
      </div>
      <div className="header-item">
        <div className="header-item-row-text" style={{ color: "#FDBA2C" }}>
          {t("active")}：{numActive}
          {t("name")}
        </div>
        <div className="header-item-row-text" style={{ color: "#0E6FBA" }}>
          {t("inactive")}：{numInactive}
          {t("name")}
        </div>
        <div className="header-item-row-text">
          {t("sensor_not_registered")}：{numNotRegisted}
          {t("name")}
        </div>
      </div>

      <div className="header-item">
        <div className="header-item-row" style={{ color: "#FF3131" }}>
          {t("alert")}：{numAlert}
          {t("name")}
        </div>
      </div>
      {!isAdminSanwa(userInfo) && <Select
        value={language}
        options={langOpt}
        onChange={onChangeLang}
        width={80}
      />}
    </div>
  );
}

export default AppHeader;
